import { Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useStyling } from '../../common/Theme';
import EllipsisText from '../../common/components/EllipsisText';

export default ({ title, onClick = undefined }: { title: string; onClick?: () => void }) => {
    const { theme } = useStyling();

    return (
        <Tooltip title={<Typography fontSize="small">{title}</Typography>}>
            <EllipsisText
                text={title}
                sx={{
                    fontSize: '20px',
                    fontWeight: 'bold',
                    ...(onClick && {
                        '&:hover': { cursor: 'pointer', textDecoration: 'underline', color: theme.palette.primary.main }
                    })
                }}
                onClick={onClick}
            />
        </Tooltip>
    );
};
